import React, { Component } from 'react';
import lodashFilter from 'lodash/filter';
import lodashForEach from 'lodash/forEach';
import lodashMap from 'lodash/map';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';
import { Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import { RowRenderer } from '../../Common/rowRenderer';
import { ROOT_URL, ROOT_API_URL } from '../../../actions/root_url';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';

const propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
  previouslySelectedProducts: PropTypes.arrayOf(PropTypes.object),
  dependentValues: PropTypes.shape({
    Selected: PropTypes.bool,
  }),
  modifyConvertableProductList: PropTypes.func,
};

const defaultProps = {
  products: [],
  previouslySelectedProducts: [],
  dependentValues: {},
  modifyConvertableProductList: () => {},
};

class LinkProductsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      filters: null,
      sortColumn: null,
      sortDirection: null,
    };
  }

  componentDidMount() {
    const { products, previouslySelectedProducts } = this.props;
    if (products.length > 0) {
      let rows = products;
      if (previouslySelectedProducts.length > 0) {
        rows = lodashFilter(rows, row => row.ProductNum !== previouslySelectedProducts[0].ProductNum);
        lodashForEach(previouslySelectedProducts, (prodToSelect) => {
          lodashMap(rows, (row) => {
            if (row.ProductNum === prodToSelect.ProductNum) {
              row.Selected = true;
            }
          });
        });
      }
      this.setState({ rows });
    }
  }

  selectExistingProduct = (product) => {
    const rows = JSON.parse(JSON.stringify(this.state.rows));
    lodashMap(rows, (row) => {
      if (row.ProductNum === product.ProductNum) {
        if (!row.Selected) {
          row.Selected = true;
        } else {
          row.Selected = false;
        }
      }
    });
    this.setState({ rows });
    this.props.modifyConvertableProductList(product);
  }

  render() {
    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({ filters: newFilters });
    };

    const onClearFilters = () => {
      this.setState({ filters: {} });
    };

    const CheckFormatter = React.createClass({
      render() {
        const { Selected } = this.props.dependentValues;
        if (Selected) {
          return <em className="fa fa-check" />;
        }
        return <div />;
      },
    });

    const columns = [
      {
        key: 'Selected',
        name: '',
        resizable: true,
        sortable: true,
        width: 25,
        filterable: true,
        formatter: <CheckFormatter />,
        getRowMetaData: row => row,
      },
      {
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'RefNum',
        name: isWIZ ? <Translate value="sku" /> : <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      },
      {
        key: 'Name',
        name: <Translate value="prod_name" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
      },
      {
        key: 'PackageSize',
        name: <Translate value="package_size" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 140,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <div style={{ maxWidth: '100%', marginTop: '5px' }} id="linkProductsModal-dataGrid1">
            <ReactDataGrid
              rowRenderer={<RowRenderer onDoubleClick={this.selectExistingProduct} />}
              rowKey="ProductNum"
              rowHeight={25}
              minHeight={340}
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={columns}
              toolbar={<Toolbar enableFilter />}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              enableCellSelect
            />
          </div>
        </Col>
      </Row>
    );
  }
}

LinkProductsModal.propTypes = propTypes;
LinkProductsModal.defaultProps = defaultProps;

export default LinkProductsModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/LinkProductsModal.jsx